// Shared "guide" layout: a title + intro, an optional extra block (e.g. a
// vocabulary table), a jump-to table of contents, and a stack of section
// cards. Each section is `{ title, body }` where body is trusted HTML built
// by the calling view. Ported from the legacy renderGuideSections helper;
// the only change is that the mount element is passed in rather than a global.
export function renderGuideSections(app, title, intro, sections, extraHTML, bottomHTML) {
  const toc = sections
    .map(
      (s, i) =>
        `<a href="#sec-${i}" class="text-sm text-sage-600 hover:text-sage-800 underline">${s.title}</a>`
    )
    .join('<span class="text-sage-300">·</span>');

  const body = sections
    .map(
      (s, i) => `
    <section id="sec-${i}" class="bg-white rounded-2xl border border-sage-100 p-5 sm:p-6 scroll-mt-24">
      <h3 class="text-lg font-bold text-sage-800 mb-2">${s.title}</h3>
      ${s.body}
    </section>
  `
    )
    .join("");

  app.innerHTML = `
    <section class="max-w-4xl mx-auto">
      <h2 class="text-3xl font-bold text-sage-800 mb-2">${title}</h2>
      <p class="text-sage-600 mb-4">${intro}</p>
      ${extraHTML || ""}
      <div class="bg-sage-50 border border-sage-100 rounded-xl p-3 mb-6 flex flex-wrap gap-x-3 gap-y-1 items-center">
        <span class="text-xs uppercase tracking-wide text-sage-500 font-semibold mr-1">Jump to:</span>
        ${toc}
      </div>
      <div class="space-y-4">
        ${body}
      </div>
      ${bottomHTML || ""}
    </section>
  `;
}
